const buildExpressionContext = (answers = {}) => {
  return Object.entries(answers).reduce((acc, [key, value]) => {
    acc[key] = value;
    return acc;
  }, {});
};

export const evaluateShowWhen = (expression, answers = {}) => {
  if (!expression || typeof expression !== 'string') return true;
  try {
    const context = buildExpressionContext(answers);
    const evaluator = new Function('ctx', `with (ctx) { return Boolean(${expression}); }`);
    return Boolean(evaluator(context));
  } catch (error) {
    return true;
  }
};
